const Logo = (props) => (
  <img
    className="main_logo"
    alt="Logo"
    src="/static/images/logos/logo.png"
    {...props}
  />
);

export default Logo;
